module.exports = __webpack_public_path__ + "static/4BHK-03-Kitchen-30f3f7dfebf850a3edadb79c10e5e1ba.jpg";